export class Controller {

    /** @ngInject */
    constructor($state,$uibModal,Alert) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    $onInit() {
        const type = this.application.applicationType.slug;
    }
    showRemoveModal(remoteAppId) {
        this.$uibModal
            .open({
                component: 'companyManageApplicationRemoteAppRemove',
                resolve: {
                    companyId: () => this.companyId,
                    appId: () => this.appId,
                    remoteAppId: () => remoteAppId,
                },
            }).result
            .then(() => {
                const index = this.remoteApps.findIndex(obj => obj.sraRemoteApp.id === remoteAppId);
                if(index!=-1) {
                this.remoteApps.splice(index, 1);
                this.Alert('success', 'company.manage-application.remote-app-access.remove.removed');
                }
                
            })
    }

    
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/remote-app-access.controller.js